/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Shop_Home_Row_Enabled_AriaInputs */

const vi_shop_home_row_enabled_aria = /** @type {(inputs: Shop_Home_Row_Enabled_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bật ${i?.name}`)
};

/**

* @param {Shop_Home_Row_Enabled_AriaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_row_enabled_aria = /** @type {((inputs: Shop_Home_Row_Enabled_AriaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Row_Enabled_AriaInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_row_enabled_aria(inputs)
});